import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { findLineItems, getSectionPath } from "shared/selectors/unit";
import { handleScrollTop } from "shared/helpers/scrollTo";
import CardGrid from "../cardGrid/CardGrid";
import { navigationButton } from "../../helpers/navigationButton";
import LineItemPicker from "./pickers/LineItemPicker";
import { withRouter } from "../../helpers/withRouter";

class LineItemList extends React.Component {
  static propTypes = {
    lineItems: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div data-component="lineItemList">
        <LineItemPicker>
          {picker => {
            return (
              <div data-component="line_items">
                <CardGrid items={this.renderCardItems(picker)} />
              </div>
            );
          }}
        </LineItemPicker>
      </div>
    );
  }

  renderCardItems = picker => {
    const { lineItems, sectionPath } = this.props;
    return lineItems.map(lineItem => {
      if (lineItem.isMandatoryDisplay) {
        return {
          ...this.renderBaseLineItem(lineItem),
          total: lineItem.totalMin
        };
      }

      if (lineItem.isActivated) {
        return {
          ...this.renderBaseLineItem(lineItem),
          total: lineItem.total,
          url: `${sectionPath}/line_item/${lineItem.id}`
        };
      }

      // if isReplacement or Optional
      return {
        ...this.renderBaseLineItem(lineItem),
        total: lineItem.totalMin,
        onClick: () => {
          picker.select(lineItem).then(this.navigateTo, () => {});
        }
      };
    });
  };

  renderBaseLineItem = lineItem => ({
    button: navigationButton(lineItem),
    imageClass: lineItem.imageClass,
    imageUrl: lineItem.thumbUrl,
    isBasePrice: !lineItem.isActivated,
    isMandatoryDisplay: lineItem.isMandatoryDisplay,
    isPriceOnRequest: lineItem.isPriceOnRequest,
    key: lineItem.id.toString(),
    title: lineItem.title,
    modelType: "line_item"
  });

  navigateTo = lineItem => {
    const { sectionPath, router } = this.props;

    handleScrollTop();
    if (lineItem.subLineItemIds.length > 1) {
      router.push(
        `${sectionPath}/line_item/${lineItem.id}/sub_line_item/${lineItem.subLineItemIds[0]}`
      );
    } else {
      router.push(`${sectionPath}/line_item/${lineItem.id}`);
    }
  };
}

const mapStateToProps = (state, props) => {
  const { sectionId } = props.params;
  let lineItems = [];

  if (props.lineItems) {
    lineItems = props.lineItems;
  } else {
    lineItems = findLineItems(state)(sectionId).filter(li => {
      return (
        li.isVisible &&
        li.isConfigurable &&
        !li.isReplaced &&
        (!li.isReplacement || li.isActivated)
      );
    });
  }

  const sectionPath = getSectionPath(props);
  return {
    sectionPath,
    lineItems
  };
};

export default withRouter(connect(mapStateToProps)(LineItemList));
